import { render, staticRenderFns } from "./EmployeeStatus.vue?vue&type=template&id=4f5be4fc&scoped=true"
import script from "./EmployeeStatus.vue?vue&type=script&lang=js"
export * from "./EmployeeStatus.vue?vue&type=script&lang=js"
import style0 from "./EmployeeStatus.vue?vue&type=style&index=0&id=4f5be4fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5be4fc",
  null
  
)

export default component.exports